import React, { useEffect, useRef } from "react";
import VanillaTilt from "vanilla-tilt";

function TiltCard({ children, options, className }) {
  const tiltRef = useRef(null);

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, options || {
        speed: 250,
        max: 10,
        perspective: 500,
      });
    }
    return () => tiltRef.current?.vanillaTilt?.destroy();
  }, []);

  return (
    <div ref={tiltRef} className={`tilt-card ${className || ""}`}>
      {children}
    </div>
  );
}

export default TiltCard;